import {
  EValue,
  ISearchTypeTermFieldSchema,
} from '../../repositories/newbuilding-promos/entities/json_query/SearchTypeTermFieldSchema';
import { ESearchType, IJsonQuerySearchType } from '../../types/jsonQuery/searchType';
import { EJsonQueryType } from '../../types/jsonQuery/term';

const SEARCH_TYPE_MAP = new Map([
  [EValue.Bonus, ESearchType.Bonus],
  [EValue.CianMortgage, ESearchType.CianMortgage],
  [EValue.Discount, ESearchType.Discount],
  [EValue.FromBuilder, ESearchType.FromBuilder],
  [EValue.MaternalCapital, ESearchType.MaternalCapital],
  [EValue.Military, ESearchType.Military],
  [EValue.Mortgage, ESearchType.Mortgage],
  [EValue.MortgageFromBank, ESearchType.MortgageFromBank],
  [EValue.MortgageFromBuilder, ESearchType.MortgageFromBuilder],
]);

export function mapSearchType(term?: ISearchTypeTermFieldSchema | null): IJsonQuerySearchType | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Term,
    value: SEARCH_TYPE_MAP.get(term.value) as ESearchType,
  };
}
